import * as React from 'react'
import { useTasks } from './store'

export type TaskTypeProps = {
	name: string
	element: any
}

export function TaskType(props: TaskTypeProps) {
	const registerType = useTasks((state) => state.registerType)

	React.useEffect(() => {
		registerType(props.name, { Component: props.element })
	}, [props.element, props.name, registerType])

	return null
}
